const state = {
  // 1为默认头部、2为注册头部 -- 同步底部样式
  headerStyle: 1
};

const getters = {};

const actions = {
  // 设置头部样式
  setHeaderStyle(context, val) {
    context.commit('setHeaderStyle', val);
  }
};

const mutations = {
  // 设置头部样式
  setHeaderStyle(state, val) {
    state.headerStyle = val;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/app.js